import React from 'react'
import Card from '../../../../../reusableComponents/cards/Card71'
import InfoCardSwap from './InfoCardSwap'

const InfoCard = ({ batchInfo = {} }) => {
  return (
    <div>
      <Card
        showTitle={false}
        showDescription={false}
        showPrimaryButton={false}
        showSecondaryButton={false}
        showMenuButton={false}
        showSwapComponent1={true}
        showSwapComponent2={false}
        showSwapComponent3={false}
        swapContent1={<InfoCardSwap batchInfo={batchInfo} />}
      />
    </div>
  )
}

export default InfoCard